import { ApiEntity } from "../../Api/api.model";
import { string, type, boolean, nullable } from "superstruct";
import { validateStruct } from "../../../utils/validate";
import { MediaAsset, MediaAssetStruct } from "../../../utils/assets";
import { extractLocker } from "../../serviceUtils";

export interface Reward {
  id: string;
  name: string;
  title: string;
  description: string;
  subTitle: string;
  promotion: string;
  redeemUrl: string;
  lock: {
    locked: boolean;
    lockerId?: string;
  };
  coverImg: MediaAsset;
}

const RewardStruct = type({
  id: string(),
  name: string(),
  title: string(),
  description: string(),
  subTitle: string(),
  promotion: string(),
  redeemUrl: string(),
  lock: type({
    locked: boolean(),
    lockerId: nullable(string()),
  }),
  coverImg: MediaAssetStruct,
});
export class RewardEntity extends ApiEntity<Array<Reward>> {
  constructor() {
    super("rewards");
  }
  validate(rawData: Array<{}>): Array<Reward> {
    return rawData.map((rawItem) =>
      validateStruct<Reward>(rawItem, RewardStruct, this.endPoint, [
        { field: "id", transform: (id: number) => id.toString() },
        { field: "lock", transform: extractLocker },
        { field: "id", transform: (id: number) => id.toString() },
      ])
    );
  }
}
